import { render, staticRenderFns } from "./FinancePayoutsTotals.vue?vue&type=template&id=5406c8c1&"
import script from "./FinancePayoutsTotals.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports